import {
  DEALER_QUERY_SUBMITTING,
  DEALER_QUERY_SUCCESS,
  DEALER_QUERY_ERROR,
  // DEALER_OBJECT_UPDATE
} from '../constants';
import { getDealersByZip } from '../../services';
// import { get } from '../../utils';

export function getDealerActionFromState() {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({
      type: DEALER_QUERY_SUBMITTING,
    });
    getDealersByZip(state).then((response) => {
      if (response[0].error) {
        dispatch({
          type: DEALER_QUERY_ERROR,
          error: 'COULD NOT FETCH DEALERS'
        });
        return false;
      }
      return response;
    })
      .then((result) => {
        if (result.length > 30) {
          dispatch({
            type: DEALER_QUERY_SUCCESS,
            dealersObject: { dealers: result.slice(0, 30), totalResults: 30 }
          });
        } else {
          dispatch({
            type: DEALER_QUERY_SUCCESS,
            dealersObject: { dealers: result, totalResults: result.length }
          })
        }
      })
    // .catch((error) => {
    //   dispatch({
    //     type: DEALER_QUERY_ERROR,
    //     error
    //   });
    // });
  }
}

export function updateDealerActionByZip(zipCode) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({
      type: DEALER_QUERY_SUBMITTING,
    });
    getDealersByZip(state, zipCode).then((response) => {
      if (response[0].error) {
        dispatch({
          type: DEALER_QUERY_ERROR,
          error: 'COULD NOT FETCH DEALERS'
        });
        return false;
      }
      return response;
    }).then((result) => {
      if (result.length > 30) {
        dispatch({
          type: DEALER_QUERY_SUCCESS,
          dealersObject: { dealers: result.slice(0, 30), totalResults: 30 }
        });
      } else {
        dispatch({
          type: DEALER_QUERY_SUCCESS,
          dealersObject: { dealers: result, totalResults: result.length }
        })
      }
    })
    // .catch((error) => {
    //   dispatch({
    //     type: DEALER_QUERY_ERROR,
    //     error
    //   });
    // });
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/dealers.js
 **/